import { BizRouterLayout } from "@dust-tt/front/components/biz/BizRouterLayout";
import { withSuspense } from "@spa/app/routes/withSuspense";
import type { RouteObject } from "react-router-dom";

const TaxInvoicesPage = withSuspense(
  () => import("@dust-tt/front/components/pages/biz/TaxInvoicesPage"),
  "TaxInvoicesPage"
);

// /w/:wId/biz — the 업무(Korean business-ops) hub. A parent layout renders the
// left sub-nav + <Outlet/>; each child is a module page. 세금계산서 is the
// first module; 주주명부/전자서명 등 will be added as siblings. Tax-invoices is
// the index.
export const bizRoutes: RouteObject[] = [
  {
    path: "biz",
    element: <BizRouterLayout />,
    children: [
      { index: true, element: <TaxInvoicesPage /> },
      { path: "tax-invoices", element: <TaxInvoicesPage /> },
    ],
  },
];
